/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleDeviceCreate
 */
export interface VehicleDeviceCreate {
    /**
     * 
     * @type {string}
     * @memberof VehicleDeviceCreate
     */
    vehicleId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDeviceCreate
     */
    serialNumber: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDeviceCreate
     */
    hardwareKey: string;
    /**
     * 
     * @type {Date}
     * @memberof VehicleDeviceCreate
     */
    firmwareLastUpdatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof VehicleDeviceCreate
     */
    currentVersion: string;
}

/**
 * Check if a given object implements the VehicleDeviceCreate interface.
 */
export function instanceOfVehicleDeviceCreate(value: object): value is VehicleDeviceCreate {
    if (!('serialNumber' in value) || value['serialNumber'] === undefined) return false;
    if (!('hardwareKey' in value) || value['hardwareKey'] === undefined) return false;
    if (!('firmwareLastUpdatedAt' in value) || value['firmwareLastUpdatedAt'] === undefined) return false;
    if (!('currentVersion' in value) || value['currentVersion'] === undefined) return false;
    return true;
}

export function VehicleDeviceCreateFromJSON(json: any): VehicleDeviceCreate {
    return VehicleDeviceCreateFromJSONTyped(json, false);
}

export function VehicleDeviceCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleDeviceCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'vehicleId': json['vehicleId'] == null ? undefined : json['vehicleId'],
        'serialNumber': json['serialNumber'],
        'hardwareKey': json['hardwareKey'],
        'firmwareLastUpdatedAt': (new Date(json['firmwareLastUpdatedAt'])),
        'currentVersion': json['currentVersion'],
    };
}

export function VehicleDeviceCreateToJSON(json: any): VehicleDeviceCreate {
    return VehicleDeviceCreateToJSONTyped(json, false);
}

export function VehicleDeviceCreateToJSONTyped(value?: VehicleDeviceCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vehicleId': value['vehicleId'],
        'serialNumber': value['serialNumber'],
        'hardwareKey': value['hardwareKey'],
        'firmwareLastUpdatedAt': value['firmwareLastUpdatedAt'].toISOString(),
        'currentVersion': value['currentVersion'],
    };
}

